export const TRUE = 'Yes'
export const FALSE = 'No'
